import "@radix-ui/themes/styles.css";
import { Theme } from "@radix-ui/themes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth";
import "./styles.css";
import { applyTheme, getInitialTheme } from "./theme";

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 } } });
applyTheme(getInitialTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Theme accentColor="green" grayColor="sand" radius="medium" scaling="100%">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter><AuthProvider><App /></AuthProvider></BrowserRouter>
      </QueryClientProvider>
    </Theme>
  </StrictMode>,
);
